export default {
    methods: {
        backgroundClick(event) {
            let result = false;

            if (event.target === this.$refs.designerScroll.$refs.target) {
                result = true;
            } else if (event.target.classList.contains("gutter-container")) {
                result = true;
            }

            return result;
        }
    }
};
